﻿import {DateTime, DayOfWeek} from "@2d-front-monorepo/core";
import {ParkingPrebookingAvailabilityEntry} from "@2d-front-monorepo/permits-business";
import {SelectedParkingPrebookingAvailabilityEntry} from "../types/ParkingPrebookingAvailabilityEntry";
import {isDateRangeValid} from "./isRangeValid";
import {MultiOperationSegment} from "./MultiOperationSegment";

export class MultiOperationPermit implements Iterable<MultiOperationSegment> {
	private readonly _availability: ParkingPrebookingAvailabilityEntry[];
	private readonly _segments: MultiOperationSegment[];
	private readonly _alwaysValidWeekDays: DayOfWeek[];

	constructor(availability: ParkingPrebookingAvailabilityEntry[], alwaysValidWeekDays?: DayOfWeek[]) {
		this._availability = availability.sort((a, b) =>
			a.startDate.compareTo(b.startDate)
		);

		this._alwaysValidWeekDays = alwaysValidWeekDays ?? [];
		this._segments = [];
	}

	get availability(): ParkingPrebookingAvailabilityEntry[] {
		return this._availability;
	}

	get size(): number {
		return this._segments.length;
	}

	getSelected(): SelectedParkingPrebookingAvailabilityEntry[] {
		return this._segments.map(s => s.toPrebookingEntry());
	}

	at(index: number): MultiOperationSegment | undefined {
		return this._segments.at(index);
	}

	clear(): void {
		this._segments.length = 0;
	}

	remove(start: number, length: number = 0): void {
		this._segments.splice(start, length <= 0 ? Infinity : length);
	}

	tryCreateSegment(startDate: DateTime, endDate: DateTime): boolean {
		if (!isDateRangeValid(this._availability, startDate, endDate, this._alwaysValidWeekDays)) {
			return false;
		}

		this._segments.push(new MultiOperationSegment(startDate, endDate));
		return true;
	}

	[Symbol.iterator](): Iterator<MultiOperationSegment> {
		let index = 0;
		const entries = this._segments;

		return {
			next: (): IteratorResult<MultiOperationSegment> => {
				if (index < entries.length) {
					return {value: entries[index++], done: false};
				} else {
					return {value: undefined, done: true};
				}
			}
		};
	}
}
